import Button from '@loggi/ui/components/button';
import { ROUNDED_SHAPE } from '@loggi/ui/components/button/types';
import Col from '@loggi/ui/components/col';
import Text from '@loggi/ui/components/text';
import PropTypes from 'prop-types';
import React from 'react';
import styles from './confirm-original-address.styles.scss';

export const CONFIRM_ORIGINAL_ADDRESS_ID = 'confirm-original-address';

export default function ConfirmOriginalAddress({
  onClickToDeny,
  onClickToConfirm,
  questionText,
  confirmButtonText,
  denyButtonText
}) {
  return (
    <Col
      className={styles.confirmOriginalAddress}
      data-testid={CONFIRM_ORIGINAL_ADDRESS_ID}
    >
      <Text bold>{questionText}</Text>
      <Col gutter={{ top: 'normal' }} flexDirection="row">
        <Col gutter={{ right: 'normal' }}>
          <Button
            shape={ROUNDED_SHAPE}
            size="small"
            style="outline"
            value={denyButtonText}
            onClick={onClickToDeny}
          />
        </Col>
        <Button
          shape={ROUNDED_SHAPE}
          size="small"
          style="outline"
          value={confirmButtonText}
          onClick={onClickToConfirm}
        />
      </Col>
    </Col>
  );
}

ConfirmOriginalAddress.displayName = 'ConfirmOriginalAddress';

ConfirmOriginalAddress.propTypes = {
  onClickToDeny: PropTypes.func.isRequired,
  onClickToConfirm: PropTypes.func.isRequired,
  questionText: PropTypes.string.isRequired,
  confirmButtonText: PropTypes.string.isRequired,
  denyButtonText: PropTypes.string.isRequired
};
